<!-- <div id="tracker-container" class="card-container">
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="card-title font-weight-bold">Fichar</h4>
            <h4 class="card-title font-weight-bold">{{ 'todayInfo' }}</h4>
        </div>
        <div class="card-content">
            <div class="registration-tracker-body d-flex flex-row card-body justify-content-around">
                <div
                    class="timer d-flex align-items-center justify-content-center font-weight-bold h4 mb-0 text-center">
                    {{ 'btnTimerContent' }}
                </div>
                <button *ngIf="'timerIsRunning'" [disabled]="areBtnDisabled" (click)="handleBtnTimer('pause')"
                    class="btn btn-warning btn-timer-pause text-white">
                    {{ btnTimerPauseText }}
                </button>
                <button [ngClass]="'btnTimerClass'" [disabled]="'areBtnDisabled || isFinished'"
                    class="btn btn-timer text-white" >
                    {{ 'btnTimerText' }}
                </button>
            </div>
        </div>
    </div>
</div> -->

<section id="registration-tracker-navbar">
    <div class="d-flex ">
        <div class="timer d-flex align-items-center justify-content-center font-weight-bold h5 mb-0 text-center">
            {{ timer }}
        </div>
        <div class="btn-container d-flex ml-4">
            <button *ngIf="!hasStarted || hasFinished" [disabled]="hasFinished" (click)="start()"
                class="btn btn-success text-white">
                Empezar
            </button>
            <button *ngIf="hasStarted && timerIsRunning && !hasFinished" (click)="pause()"
                class="btn btn-warning text-white">
                Pausar
            </button>
            <button *ngIf="hasStarted && !timerIsRunning && !hasFinished" (click)="start()"
                class="btn btn-warning text-white">
                Continuar
            </button>
            <button *ngIf="hasStarted && !hasFinished" (click)="finish()" class="btn red-bg text-white">
                Terminar
            </button>
        </div>
    </div>
</section>